import type { InventoryVehicle } from '@carvana/merch-contracts';
import { useContext } from 'react';
import { VDPLinkTitles } from '~/constants/home/VdpLinkTitles';
import FavoritesContext from '~/context/home/FavoritesContext';
import RecentVehiclesContext from '~/context/home/RecentVehiclesContext';
import SuggestedForYouContext from '~/context/home/SuggestedForYouContext';
import selectVdpLinks from '~/utilities/home/selectVdpLinks';

type HookReturnType = {
  header: VDPLinkTitles;
  showLink?: boolean;
  showLoading: boolean;
  vehicles: InventoryVehicle[];
};

const loading: HookReturnType = {
  header: VDPLinkTitles.None,
  showLoading: true,
  vehicles: []
};

export default function useGetVDPLinksToShow(): HookReturnType {
  const {
    favoriteVehiclesFromSearch: {
      data: favoriteVehicles,
      isLoaded: isFavoritesLoaded
    }
  } = useContext(FavoritesContext);
  const {
    recentVehiclesFromSearch: { data: recentVehicles, isLoaded: isRecentLoaded }
  } = useContext(RecentVehiclesContext);
  const {
    suggestedVehicles: { data: suggestedVehicles, isLoaded: isSuggestedLoaded }
  } = useContext(SuggestedForYouContext);

  if (!isFavoritesLoaded || !isRecentLoaded || !isSuggestedLoaded) {
    return loading;
  }

  const vdpLinks = selectVdpLinks({
    favorites: favoriteVehicles,
    recent: recentVehicles,
    suggested: suggestedVehicles
  });

  return vdpLinks ? { ...vdpLinks, showLoading: false } : loading;
}
